import Button from "@mui/material/Button";
import * as React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Divider from "@mui/material/Divider";
import DeleteResourceModal from "./DeleteResourceModal";
import { useNavigate, useParams } from "react-router-dom";
import { axiosInstance } from "./axiosFetchers";
import { useAuth } from "./Auth/useAuth";

export default function EditFarmButton({
  text,
  onClick,
  grow = false,
  secondary = false,
  disabled = false,
  farmName = "this farm",
}) {
  const { farmId } = useParams();
  const [isWarningModalOpen, setIsWarningModalOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleDeleteFarm = async (farmId) => {
    await axiosInstance.delete(
      `${process.env.REACT_APP_API_URL}/farms/${farmId}`,
      {
        headers: {
          token: "Bearer " + user.token,
          provider: user.provider,
          "Content-Type": "application/json",
        },
      }
    );
    navigate("/dashboard");
    window.location.reload();
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  if (disabled) {
    return (
      <Button variant="contained" disabled>
        {text}{" "}
      </Button>
    );
  }
  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        variant="contained"
        sx={{
          bgcolor: "rgb(241,93,34)",
          "&:hover": {
            backgroundColor: "rgb(211,70,13)",
          },
        }}
      >
        Edit Farm
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem
          onClick={() => {
            handleClose();
            navigate(`/farm/${farmId}/form`);
          }}
        >
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Edit Farm</ListItemText>
        </MenuItem>
        <Divider component="li" />
        <MenuItem onClick={() => setIsWarningModalOpen(true)}>
          <ListItemIcon>
            <DeleteIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Delete Farm</ListItemText>
        </MenuItem>
      </Menu>
      <DeleteResourceModal
        title={"Delete Farm"}
        description={`Are you sure you wish to permanently delete ${farmName}?
        
        \nPlease note that deleting your farm deletes all associated fields and crop years and all associated data. This information cannot be recovered. If any crop years are associated with Projects, those associations will also be deleted.

        Are you sure you wish to permanently delete this farm and all associated data?
        `}
        open={isWarningModalOpen}
        handleClose={setIsWarningModalOpen}
        handleDelete={handleDeleteFarm}
        resourceId={farmId}
      />
    </div>
  );
}
